<itl-wizard-page
  isSinglePage="true"
  (doneClicked)="saveValuesAndCloseModal()"
  [pageIsValid]="!isValueMissing"
  (cancelClicked)="_modalCtrl.dismiss()"
  [pageTitleTransPath]="'woundMeasure.modalTitle' | translate"
>
  <ion-content scroll="false">
    <div class="toolsContainer">
      <itl-toolbar
      [showInfoBox]="true"
      [infoBoxText]="woundSelected ? ('woundMeasure.changeWoundInfoText' | translate) : drawMode ? ('woundMeasure.woundInfoBox' | translate) : ('woundMeasure.scaleInfoText' | translate)"
      infoBoxBaseColor="#004099"
      [infoBoxType]="InfoBoxType.Information"
      >
        <ng-container>
          <itl-button-small noBorder="true" (click)="switchMode(FabricMode.Measure)" [ngClass]="{'activeMode': !drawMode}">
            <ion-icon class="buttonIcon" name="alberta-ruler-outline"></ion-icon>
            <span class="buttonText noWrap">{{'woundMeasure.setScale' | translate}}</span>
          </itl-button-small>
          <itl-button-small noBorder="true" (click)="switchMode(FabricMode.Draw)" [ngClass]="{'activeMode': drawMode}">
            <ion-icon class="buttonIcon" name="alberta-brush-outline"></ion-icon>
            <span class="buttonText noWrap">{{'woundMeasure.selectWound' | translate}}</span>
          </itl-button-small>
          <hr class="vertical" />
          <itl-button-small noBorder="true" (click)="zoomIn()" [disabled]="zoomInDisabled">
            <ion-icon class="buttonIcon" name="alberta-zoom-in-outline"></ion-icon>
          </itl-button-small>

          <itl-button-small noBorder="true" (click)="zoomOut()" [disabled]="zoomOutDisabled">
            <ion-icon class="buttonIcon" name="alberta-zoom-out-outline"></ion-icon>
          </itl-button-small>
          <hr class="vertical" />
          <itl-button-small noBorder="true" (click)="resetDrawing()" class="redButton">
            <ion-icon class="buttonIcon redIcon" name="alberta-reset-outline"></ion-icon>
          </itl-button-small>
          <hr class="vertical" />
          <itl-button-selection
          [possibleSelections]="tenantScales"
          (change)="scaleChanged($event)"
          noBorder="true"
          [ngModel]="selectedScaleInMillimeter"
          [disabled]="scaleSelectionDisabled"
          [title]="'woundMeasure.scale' | translate"
          >
          </itl-button-selection>
        </ng-container>
      </itl-toolbar>
      <div *ngIf="woundSelected" class="woundMeasurements bold">
        <div class="measurementContainer">
          {{'woundMeasure.heightTitle' | translate}}:
          <div class="values">{{woundHeightStringCm}} cm</div>
        </div>
        <div class="measurementContainer">
          {{'woundMeasure.widthTitle' | translate}}:
          <div class="values">{{woundWidthStringCm}} cm</div>
        </div>
        <div class="measurementContainer">
          {{'woundMeasure.areaTitle' | translate}}:
          <div class="values">{{woundAreaStringCm}} cm<sup>2</sup></div>
        </div>
      </div>
    </div>
    
    <div class="woundContainer">
      <canvas id="woundMeasureCanvas" class="woundCanvas"></canvas>
    </div>

  </ion-content>
</itl-wizard-page>